import React, {Dispatch, ReactNode, SetStateAction} from 'react';
import Table, {SetOrderByType} from 'shared/ui/Table/Table';
import IPagination from 'shared/api/model/IPagination';
import IOrderBy from 'shared/model/IOrderBy';
import IHttpIncident from 'features/http/model/HttpIncident/IHttpIncident';
import useHttpIncidents from 'features/http/model/useHttpIncidents';

import HttpIncidentRow from '../HttpIncidentRow/HttpIncidentRow';

import styles from './HttpIncidents.module.scss';

interface IHttpIncidentsProps {
    pagination?: IPagination<IHttpIncident>,
    isLoading: boolean,
    hidePagination?: boolean,
    hideMonitor?: boolean,
    sort?: IOrderBy,
    setSort?: SetOrderByType,
    setPage?: Dispatch<SetStateAction<number>>,
    emptyStateComponent?: ReactNode,
    plug?: ReactNode,
}

const HttpIncidents: React.FC<IHttpIncidentsProps> = ({
    pagination,
    isLoading,
    hidePagination = false,
    hideMonitor = false,
    sort,
    setSort,
    setPage,
    emptyStateComponent = true,
    plug,
}) => {
    const {columns, tzString} = useHttpIncidents(hideMonitor);

    return (
        <div className={styles.container}>
            <Table
                columns={columns}
                items={pagination?.items}
                rowFactory={item =>
                    <HttpIncidentRow
                        key={item.id}
                        item={item}
                        tzString={tzString}
                        hideMonitor={hideMonitor}
                    />
                }
                isLoading={isLoading}
                pagination={pagination && !hidePagination ? pagination : undefined}
                sort={sort}
                setSort={setSort}
                setPage={setPage}
                emptyStateComponent={emptyStateComponent}
            />
            {plug}
        </div>
    );
};

export default HttpIncidents;
